var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "#fff",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "DO_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#DO_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8h12V0H0v8zM16 20h12v-8H16v8z",
    fill: "#083D7A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20h12v-8H0v8zM16 8h12V0H16v8z",
    fill: "#DF1E35"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "DO_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.586 8.586a2 2 0 102.829 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.115 8.114a2.667 2.667 0 000 3.772l.942-.943a1.333 1.333 0 010-1.886l-.942-.943zm0 3.772a2.667 2.667 0 003.77 0l-.942-.943c-.52.52-1.365.52-1.886 0l-.942.943zm3.77 0a2.667 2.667 0 000-3.772l-.942.943c.52.52.52 1.365 0 1.886l.943.943z",
    fill: "#0F6D1A",
    mask: "url(#DO_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10.667a.667.667 0 100-1.333.667.667 0 000 1.333z",
    fill: "#042F60"
  }))));
}
export default SvgDo;